var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCharla(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -20 512 512",
    width: 40,
    height: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M256 0C120.55 0 0 92.375 0 217.988c0 45.88 16.29 89.32 47.234 126.29L20.641 446.96c-3.946 15.226 10.523 28.934 25.566 24.023l135.672-44.28c23.969 6.155 48.871 9.273 74.121 9.273 135.535 0 256-92.465 256-217.989C512 91.391 390.242 0 256 0zm0 395.977c-23.703 0-47.02-3.16-69.293-9.387a20.04 20.04 0 00-11.594.246L68.52 421.629l20.093-77.578a19.997 19.997 0 00-4.66-18.57C55.2 294.304 40 257.132 40 217.987c0-98.144 96.898-177.992 216-177.992s216 79.848 216 177.992-96.898 177.989-216 177.989zm25-177.993c0 13.809-11.191 25-25 25s-25-11.191-25-25c0-13.804 11.191-25 25-25s25 11.196 25 25zm100 0c0 13.809-11.191 25-25 25s-25-11.191-25-25c0-13.804 11.191-25 25-25s25 11.196 25 25zm-200 0c0 13.809-11.191 25-25 25s-25-11.191-25-25c0-13.804 11.191-25 25-25s25 11.196 25 25zm0 0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharla);
export default __webpack_public_path__ + "static/media/charla.74de7e65a15ff0ac79eb5c1ba27fa805.svg";
export { ForwardRef as ReactComponent };